function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useLayoutEffect } from 'react';
import { usePrefixCls } from '@okee-uikit/react-config';
import { useChildrenEnterLeave } from '../../../hooks/animation';
import { useFilesUpdate, useUpload } from '../rc-upload';
import { TextFileListItem } from './TextFileListItem';
import { CardFileListItem } from './CardFileListItem';
import { PictureFileListItem } from './PictureFileListItem';
var Effect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
export function FileList(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      actions = props.actions,
      hasClose = props.hasClose,
      disableAnimation = props.disableAnimation,
      iconRender = props.iconRender,
      _props$size = props.size,
      size = _props$size === void 0 ? {
    width: '400px',
    height: '160px'
  } : _props$size,
      children = props.children,
      renderFileItem = props.renderFileItem;
  var fileUpload = useUpload();
  var FileListCls = usePrefixCls('upload-file-list', {
    text: type === 'text',
    card: type === 'card',
    picture: type === 'picture'
  });

  var _children = fileUpload.files.map(function (file, index) {
    if (type === 'text') {
      return React.createElement(TextFileListItem, {
        key: file.id,
        file: file,
        iconRender: iconRender
      });
    }

    if (type === 'card') {
      return React.createElement(CardFileListItem, {
        key: file.id,
        file: file,
        iconRender: iconRender
      });
    }

    return React.createElement(PictureFileListItem, {
      key: file.id,
      file: file,
      size: size,
      actions: actions,
      hasClose: hasClose,
      iconRender: iconRender,
      renderFileItem: renderFileItem
    });
  });

  var _useChildrenEnterLeav = useChildrenEnterLeave(_children, {
    duration: 200,
    childRefKey: 'domRef',
    disabled: disableAnimation,
    enterTick: frameAnimationEnterTick
  }),
      _useChildrenEnterLeav2 = _slicedToArray(_useChildrenEnterLeav, 2),
      animatedChildren = _useChildrenEnterLeav2[0],
      startAnimation = _useChildrenEnterLeav2[1];

  useFilesUpdate();
  Effect(startAnimation);
  return React.createElement("ul", {
    className: FileListCls
  }, animatedChildren, (fileUpload.maxLength < 0 || _children.length < fileUpload.maxLength) && children);
}

function frameAnimationEnterTick(domNode, percent, memo) {
  if (percent >= 1) {
    domNode.style.removeProperty('opacity');
    domNode.style.removeProperty('margin-top');
    return memo;
  }

  var height = memo;

  if (!height) {
    var computedStyle = getComputedStyle(domNode);
    var marginBottom = parseInt(computedStyle.getPropertyValue('margin-bottom'), 10);
    height = domNode.getBoundingClientRect().height + marginBottom;
  }

  if (height) {
    domNode.style.setProperty('opacity', "".concat(percent));
    domNode.style.setProperty('margin-top', "".concat(height * (percent - 1), "px"));
  }

  return height;
}